import { Price } from "@/types/price";

export const pricingData: Price[] = [
  {
    id: "price_1NQk5TLtGdPVhGLecVfQ7mn0",
    unit_amount: 0,
    nickname: "Free",
    offers: [
      "Watch up to 3 accounts for changes",
      "Weekly change checks",
      { text: "Change history beyond the latest snapshot", available: false },
      "Generate insights for 5 prospects/day",
      "Generate outreach emails and follow-ups",
      "Save up to 25 prospects",
      { text: "Batch prospecting", available: false },
      "Open saved prospects on the website",
      {
        text: "Detailed save, search & filter prospects",
        available: false,
      },
      { text: "CSV & Excel export", available: false },
      { text: "Priority email support", available: false },
    ],
    url: "https://chromewebstore.google.com/detail/nhgeihbbpdnhcfccedpnkionaofdpaib?utm_source=item-share-cb",
  },
  {
    id: "price_1NQk55LtGdPVhGLefU8AHqH3",
    unit_amount: 4000,
    nickname: "Team",
    offers: [
      "All Pro features",
      "Watch up to 1000 accounts for changes",
      "Daily change checks",
      "365 days of change history",
      "Generate insights for 500 prospects/day",
      "Save up to 5000 prospects",
      "Batch prospecting up to 50 URLs/run",
      "Open saved prospects on the website",
      "Detailed save, search & filter prospects",
      "CSV & Excel export",
      "Priority email support",
    ],
    url: "https://signalizeaipay.lemonsqueezy.com/checkout/buy/56ab66c1-587f-453a-8d51-4cd2c3e61849?media=0&desc=0&discount=0",
  },
  {
    id: "price_1NQk55LtGdPVhGLefU8AHqHr",
    unit_amount: 1500,
    nickname: "Pro",
    offers: [
      "All Free features",
      "Watch up to 100 accounts for changes",
      "Change checks every 48 hours",
      "90 days of change history",
      "Generate insights for 50 prospects/day",
      "Save up to 200 prospects",
      "Batch prospecting up to 10 URLs/run",
      "Open saved prospects on the website",
      "Detailed save, search & filter prospects",
      "CSV & Excel export",
      "Priority email support",
    ],
    url: "https://signalizeaipay.lemonsqueezy.com/checkout/buy/9abd3513-c941-45dc-9d2f-18124ef12e9a?media=0&desc=0&discount=0",
  },
];
